/**
 * Legend component entry file8
 */


    require('./legend/LegendModel');
    require('./legend/legendAction');
    require('./legend/LegendView');

    var echarts = require('../echarts');
    // Series Filter
    echarts.registerProcessor(require('./legend/legendFilter'));



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/legend.js
// module id = 450
// module chunks = 1